export interface IVerifyOOBCode {
    email: string;
    oobCode: string;
}
